import React from 'react';
import { Flex, Skeleton } from '@duxton-web/ui';

export const MainPageSkeleton = () => {
  const renderSkeleton = () => {
    const items = [];

    for (let index = 0; index < 10; index++) {
      items.push(
        <Skeleton
          key={`skeleton-${index}`}
          active
          paragraph={{
            rows: 20,
          }}
        />,
      );
    }

    return items;
  };

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{
        padding: 24,
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {renderSkeleton()}
    </Flex>
  );
};
